import React, { ReactNode } from "react";
import { Flex, Card, Divider } from "@fluentui/react-northstar";
import styles from "./mobileViewCard.module.scss";
import { LinkButton, RegularText } from "shared/components";

export interface MobileViewCardProps {
    header: string;
    headerIcon?: ReactNode;
    headerIsLink?: boolean;
    headerOnClick?: () => void;
    detailsItems?: ReactNode[] | null;
    footer?: ReactNode;
}

export const MobileViewCard: React.FC<MobileViewCardProps> = (props) => {
    const getDetails = () => {
        if (!props.detailsItems || props.detailsItems.length === 0) {
            return null;
        }
        return (
            <Flex vAlign="center">
                {props.headerIcon ? <div className={styles.icon} /> : null}
                <Flex column fill>
                    {props.detailsItems.map((i, idx) => {
                        return (
                            <div key={`mobile_view_${idx}`} className={styles.detailsItem}>
                                {i}
                            </div>
                        );
                    })}
                </Flex>
            </Flex>
        );
    };

    return (
        <Card fluid className={styles.card}>
            <Flex column>
                <Flex vAlign="center">
                    {props.headerIcon ? <div className={styles.icon}>{props.headerIcon}</div> : null}
                    {props.headerIsLink ? <LinkButton text={props.header} onClick={() => props.headerOnClick && props.headerOnClick()} /> : <RegularText weight="bold" content={props.header} />}
                </Flex>
                <Divider />
                {getDetails()}
                {props.footer}
            </Flex>
        </Card>
    );
};
